import {useEffect, useRef} from "react";
import {useFormikContext} from "formik";

/**
 * Renders nothing. After a failed submit, scrolls the first invalid field into
 * view so the user can see why the save was rejected (required fields like
 * Status sit below the fold and their red error text was going unseen).
 */
export default function ScrollToFirstError() {
    const {submitCount, isValid, errors} = useFormikContext();
    const lastHandled = useRef(0);

    useEffect(() => {
        if (submitCount > lastHandled.current && !isValid) {
            lastHandled.current = submitCount;
            const first = Object.keys(errors)[0];
            if (!first) return;
            const el = document.querySelector(`[name="${first}"]`);
            if (el) {
                el.scrollIntoView({behavior: "smooth", block: "center"});
                if (typeof el.focus === "function") {
                    el.focus({preventScroll: true});
                }
            }
        }
    }, [submitCount, isValid, errors]);

    return null;
}
